import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-ppt-file-icon',
  templateUrl: './doc-format-ppt-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatPptFileIconComponent {}
